export const TRANSLATIONS_AR = {
  "One link for everything you make, share and sell — free, no paywall on the core tools.": "رابط واحد لكل ما تصنعه وتشاركه وتبيعه - مجانًا، بدون رسوم على الأدوات الأساسية.",
  "Footer navigation": "التنقل السفلي",
  "Explore": "استكشف",
  "Home": "الرئيسية",
  "About": "نبذة عنا",
  "QR Code Generator": "مولد رمز الاستجابة السريعة (QR)",
  "Contact": "اتصل بنا",
  "Get in touch": "تواصل معنا",
  "All rights reserved.": "جميع الحقوق محفوظة.",
  "Crop photo": "قص الصورة",
  "Drag to reposition, pinch or use the slider to zoom": "اسحب لإعادة التوجيه، أو قم بالضم أو استخدم شريط التمرير للتكبير",
  "Close": "إغلاق",
  "This image could not be opened": "تعذر فتح هذه الصورة",
  "Zoom out": "تصغير",
  "Zoom": "تكبير/تصغير",
  "Zoom in": "تكبير",
  "Reset": "إعادة ضبط",
  "Cancel": "إلغاء",
  "Saving...": "جارٍ الحفظ...",
  "Apply": "تطبيق",
  "Change language": "تغيير اللغة",
  "Main navigation": "التنقل الرئيسي",
  "Logout": "تسجيل الخروج",
  "Login": "تسجيل الدخول",
  "Open menu": "فتح القائمة",
  "Close menu": "إغلاق القائمة",
  "Language": "اللغة",
  "QR Generator": "مولد QR",
  "Download": "تنزيل",
  "About Linkakam": "نبذة عن Linkakam",
  "A link in bio tool that doesn't paywall the basics.": "أداة رابط في البايو لا تفرض رسوماً على الميزات الأساسية.",
  "Linkakam started from a simple frustration: the tools creators need most — a clean link page, a working contact form, real analytics — are usually the first things locked behind a subscription. We built Linkakam the other way around.": "بدأ Linkakam من إحباط بسيط: الأدوات التي يحتاجها صناع المحتوى أكثر من غيرها — صفحة روابط نظيفة، نموذج اتصال فعال، تحليلات حقيقية — عادة ما تكون أول الأشياء المغلقة باشتراك مدفوع. لقد قمنا ببناء Linkakam بالعكس.",
  "“We'd rather earn trust by being useful for free than earn revenue by holding features back.”": "”نفضل كسب الثقة من خلال كوننا مفيدين مجانًا بدلاً من كسب الإيرادات عن طريق حجب الميزات.“",
  "Build your page in a few minutes.": "قم ببناء صفحتك في بضع دقائق.",
  "No credit card. No trial countdown. Just your links, live.": "بدون بطاقة ائتمان. بدون فترة تجريبية. فقط روابطك، تعمل مباشرة.",
  "Create your link": "أنشئ رابطك",
  "Free means free": "مجاني تعني مجاني",
  "Your link page, forms and analytics stay free as your audience grows. No feature paywall waiting for you at 1,000 followers.": "تبقى صفحة الروابط الخاصة بك والنماذج والتحليلات مجانية مع نمو جمهورك. لا توجد ميزات مدفوعة تنتظرك عند الوصول إلى 1000 متابع.",
  "Built for creators first": "صُمم لصناع المحتوى أولاً",
  "Every tool we ship — link pages, QR codes, CVs, storefronts — starts from what people actually build with their bio link, not what upsells well.": "كل أداة نطلقها — صفحات الروابط، رموز QR، السير الذاتية، واجهات المتاجر — تبدأ مما يبنيه الأشخاص بالفعل باستخدام رابط البايو الخاص بهم، وليس مما يسهل بيعه.",
  "One link, fully yours": "رابط واحد، لك بالكامل",
  "Your profile, your links, your data. Export it, move it, or take it down whenever you want.": "ملفك الشخصي، روابطك، بياناتك. يمكنك تصديرها أو نقلها أو حذفها متى شئت.",
  "Talk to us": "تحدث إلينا",
  "Questions, feedback, or a bug to report — we read every message.": "أسئلة، ملاحظات، أو الإبلاغ عن مشكلة — نحن نقرأ كل رسالة.",
  "Email": "البريد الإلكتروني",
  "Phone": "الهاتف",
  "Name": "الاسم",
  "Subject": "الموضوع",
  "Message": "الرسالة",
  "Sending...": "جارٍ الإرسال...",
  "Send message": "إرسال الرسالة",
  "Message sent — we'll get back to you soon.": "تم إرسال الرسالة — سنرد عليك قريباً.",
  "Something went wrong sending your message. Please email us directly at support@linkakam.com.": "حدث خطأ أثناء إرسال رسالتك. يرجى مراسلتنا مباشرة على support@linkakam.com.",
  "Everything you make,": "كل ما تصنعه،",
  "one link away.": "على بُعد رابط واحد.",
  "Create a single, shareable link for all your social profiles, business pages, product catalogs and menus — with built-in forms, analytics and QR codes, free.": "قم بإنشاء رابط واحد قابل للمشاركة لجميع ملفاتك الشخصية على وسائل التواصل الاجتماعي، صفحات الأعمال، كتالوجات المنتجات والقوائم — مع نماذج مدمجة، تحليلات، ورموز QR، مجانًا.",
  "See how it works": "شاهد كيف يعمل",
  "Search For Profile": "البحث عن ملف شخصي",
  "Search": "بحث",
  "A Linkakam profile page on a phone": "صفحة ملف Linkakam الشخصي على الهاتف",
  "Profile visits": "زيارات الملف الشخصي",
  "Scan to share": "امسح للمشاركة",
  "How it works": "كيف يعمل",
  "Back to home": "العودة للرئيسية",
  "Search results": "نتائج البحث",
  "Searching...": "جارٍ البحث...",
  "profile": "ملف شخصي",
  "profiles": "ملفات شخصية",
  "for": "لـ",
  "No profiles found": "لم يتم العثور على أي ملفات شخصية",
  "Check the spelling or try a different username.": "تحقق من التهجئة أو جرب اسم مستخدم مختلف.",
  "Add all your links": "أضف جميع روابطك",
  "Connect your socials, store, videos, music, podcast and events. It all comes together on one page designed to convert.": "اربط حساباتك الاجتماعية، متجرك، مقاطع الفيديو، الموسيقى، البودكاست والفعاليات. كل ذلك يجتمع في صفحة واحدة مصممة لزيادة التفاعل.",
  "Help your followers": "ساعد متابعيك",
  "Help your followers discover everything you're sharing all over the internet, in one simple place. They'll thank you for it.": "ساعد متابعيك على اكتشاف كل ما تشاركه على الإنترنت، في مكان واحد بسيط. سوف يشكرونك على ذلك.",
  "Share it everywhere": "شاركه في كل مكان",
  "Add your unique Linkakam URL to every platform your audience is on, then use your QR code to bring offline traffic online.": "أضف رابط Linkakam الفريد الخاص بك إلى كل منصة يتواجد عليها جمهورك، ثم استخدم رمز QR الخاص بك لجلب الزوار من العالم الحقيقي إلى الإنترنت.",
  "Something went wrong. Please try again.": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "Invalid username or password": "اسم المستخدم أو كلمة المرور غير صحيحة",
  "The link was sent to your email": "تم إرسال الرابط إلى بريدك الإلكتروني",
  "check your email": "تحقق من بريدك الإلكتروني",
  "Oops...": "عذراً...",
  "Email not found": "البريد الإلكتروني غير موجود",
  "Username cannot contain spaces": "لا يمكن أن يحتوي اسم المستخدم على مسافات",
  "Please enter your email first": "يرجى إدخال بريدك الإلكتروني أولاً",
  "An error occurred": "حدث خطأ",
  "Please enter the code sent to your email": "يرجى إدخال الرمز المرسل إلى بريدك الإلكتروني",
  "Passwords do not match": "كلمات المرور غير متطابقة",
  "Please verify your email before submitting": "يرجى التحقق من بريدك الإلكتروني قبل الإرسال",
  "All your links, in one place": "جميع روابطك، في مكان واحد",
  "Register": "تسجيل حساب",
  "Please Log In": "الرجاء تسجيل الدخول",
  "Username": "اسم المستخدم",
  "Password": "كلمة المرور",
  "Remember me": "تذكرني",
  "Forgot your password?": "هل نسيت كلمة المرور؟",
  "Submit": "إرسال",
  "Don't have an account?": "ليس لديك حساب؟",
  "Register Please": "الرجاء التسجيل",
  "User Name": "اسم المستخدم",
  "email": "البريد الإلكتروني",
  "Verified": "تم التحقق",
  "Resend": "إعادة إرسال",
  "Verify": "تحقق",
  "Enter the 6-digit code": "أدخل الرمز المكون من 6 أرقام",
  "Checking...": "جارٍ التحقق...",
  "Confirm": "تأكيد",
  "Confirm Password": "تأكيد كلمة المرور",
  "Already have an account?": "لديك حساب بالفعل؟",
  "Reset password": "إعادة تعيين كلمة المرور",
  "Enter your email and you will receive a reset password link": "أدخل بريدك الإلكتروني وستتلقى رابطاً لإعادة تعيين كلمة المرور",
  "Verify your email": "تأكيد بريدك الإلكتروني",
  "We sent a 6-digit code to": "أرسلنا رمزاً مكوناً من 6 أرقام إلى",
  "Verification code": "رمز التحقق",
  "Code expires in": "تنتهي صلاحية الرمز في",
  "Code expired": "انتهت صلاحية الرمز",
  "Resend code": "إعادة إرسال الرمز",
  "Back to login": "العودة لتسجيل الدخول",
  "Paste a link or type text first": "الصق رابطاً أو اكتب نصاً أولاً",
  "Couldn't generate that QR code, try a shorter link": "تعذر إنشاء رمز QR، جرب رابطاً أقصر",
  "Tool": "أداة",
  "Generate your QR code": "أنشئ رمز QR الخاص بك",
  "Turn your Linkakam profile or any link into a QR code you can print, share and download.": "حوّل ملف Linkakam الخاص بك أو أي رابط إلى رمز QR يمكنك طباعته ومشاركته وتنزيله.",
  "Link or text": "رابط أو نص",
  "Use my profile link": "استخدم رابط ملفي الشخصي",
  "QR code type": "نوع رمز QR",
  "Link / Text": "رابط / نص",
  "Wi-Fi": "واي فاي",
  "WPA/WPA2": "WPA/WPA2",
  "WEP": "WEP",
  "None": "بدون",
  "Network name (SSID)": "اسم الشبكة (SSID)",
  "Security": "الأمان",
  "Show": "إظهار",
  "Hide": "إخفاء",
  "Hidden network": "شبكة مخفية",
  "Enter the network name": "أدخل اسم الشبكة",
  "Enter the Wi-Fi password": "أدخل كلمة مرور الواي فاي",
  "Foreground color": "لون المقدمة",
  "Background color": "لون الخلفية",
  "Add Linkakam logo to the center": "إضافة شعار Linkakam في المنتصف",
  "Generating...": "جارٍ الإنشاء...",
  "Generate": "إنشاء",
  "Your QR code will appear here.": "سيظهر رمز QR الخاص بك هنا.",
  "Download PNG": "تنزيل PNG",
  "Download SVG": "تنزيل SVG",
  "Ink": "حبر",
  "Brand blue": "أزرق العلامة التجارية",
  "Accent pink": "وردي بارز",
  "White": "أبيض",
  "Soft grey": "رمادي ناعم",
  "Cover": "غلاف",
  "Change cover": "تغيير الغلاف",
  "Remove background": "إزالة الخلفية",
  "Image": "صورة",
  "Link Title": "عنوان الرابط",
  "Link": "رابط",
  "Avatar": "الصورة الرمزية",
  "link titel": "عنوان الرابط",
  "iPhone preview frame": "إطار معاينة آيفون",
  "Please wait for the image to finish uploading": "يرجى الانتظار حتى ينتهي تحميل الصورة",
  "Make sure you fill in all the fields": "تأكد من ملء جميع الحقول",
  "Could not save theme": "تعذر حفظ المظهر",
  "Please choose an image file": "يرجى اختيار ملف صورة",
  "Crop cover": "قص الغلاف",
  "Crop image": "قص الصورة",
  "Loading": "جارٍ التحميل",
  "Bio": "النبذة (البايو)",
  "Theme": "المظهر",
  "select": "تحديد",
  "Website": "الموقع الإلكتروني",
  "Call": "اتصال",
  "Other": "أخرى",
  "Add": "إضافة",
  "Add image": "إضافة صورة",
  "View as visitor": "عرض كزائر",
  "Share": "مشاركة",
  "Live preview · updates as you type": "معاينة حية · يتم التحديث أثناء الكتابة",
  "Preview": "معاينة",
  "Profile preview": "معاينة الملف الشخصي",
  "Share profile": "مشاركة الملف الشخصي",
  "Share your profile link or QR code": "شارك رابط ملفك الشخصي أو رمز QR",
  "copy": "نسخ",
  "copied": "تم النسخ",
  "No links yet.": "لا توجد روابط بعد.",
  "Powered by Linkakam": "مدعوم من Linkakam",
  "Back": "رجوع",
  "Copy profile link": "نسخ رابط الملف الشخصي",
  "Copied": "تم النسخ",
  "Copy link": "نسخ الرابط",
  "Mobile": "هاتف",
  "Tablet": "جهاز لوحي",
  "Desktop": "كمبيوتر مكتبي",
  "Please choose a JPG, PNG or WebP image": "يرجى اختيار صورة بصيغة JPG أو PNG أو WebP",
  "Image must be 5 MB or smaller": "يجب أن يكون حجم الصورة 5 ميغابايت أو أقل",
  "Something went wrong": "حدث خطأ ما",
  "Network error, please try again": "خطأ في الشبكة، يرجى المحاولة مرة أخرى",
  "Statistics": "الإحصائيات",
  "Page statistics": "إحصائيات الصفحة",
  "Back to my page": "العودة إلى صفحتي",
  "See how many people have visited your page.": "اطلع على عدد الأشخاص الذين زاروا صفحتك.",
  "Total visits": "إجمالي الزيارات",
  "Last 7 days": "آخر 7 أيام",
  "Last 30 days": "آخر 30 يومًا",
  "This month": "هذا الشهر",
  "No visits last month": "لا زيارات الشهر الماضي",
  "vs last month": "مقارنة بالشهر الماضي",
  "No visits yet": "لا زيارات بعد",
  "Share your page link to start seeing visits here.": "شارك رابط صفحتك لتبدأ برؤية الزيارات هنا.",
  "Visits per month": "الزيارات شهريًا",
  "Last 12 months": "آخر 12 شهرًا",
  "Best month": "أفضل شهر",
  "Monthly average": "المتوسط الشهري",
  "Visits today": "زيارات اليوم",
  "Daily visits": "الزيارات اليومية",
  "My page": "صفحتي",
  "Link copied": "تم نسخ الرابط",
  "Account menu": "قائمة الحساب"
};